var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"bank__item"},[_c('picture',[_c('img',{attrs:{"src":_vm.logoPath}})]),_c('span',{staticClass:"font--m-4"},[_vm._v(" "+_vm._s(_vm.bankName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }